// src/features/sightings/QuerySummary.jsx
import React from "react";

/** Pretty camera name */
function prettyCamName(k) {
  const s = String(k || "").toLowerCase();
  if (s === "41") return "41";
  if (s === "cheltenham") return "Cheltenham";
  if (s === "pool") return "Pool";
  return String(k || "");
}

/** Parse "YYYY-MM-DD HH:MM:SS" (local) -> Date */
function parseLocalYmdHms(s) {
  if (!s) return null;
  const [date, time] = String(s).split(" ");
  if (!date || !time) return null;
  const [Y, M, D] = date.split("-").map((n) => parseInt(n, 10));
  const [h, m, sec] = time.split(":").map((n) => parseInt(n, 10));
  if ([Y, M, D, h, m, sec].some((v) => Number.isNaN(v))) return null;
  return new Date(Y, M - 1, D, h, m, sec, 0);
}

/** Format M-D-YYYY HH:MM:SS AM/PM (no DOW) */
function fmtMDYHms12(s) {
  const d = s instanceof Date ? s : parseLocalYmdHms(s);
  if (!d) return "";
  const M = d.getMonth() + 1;
  const D = d.getDate();
  const Y = d.getFullYear();
  let h = d.getHours();
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  const mm = String(d.getMinutes()).padStart(2, "0");
  const ss = String(d.getSeconds()).padStart(2, "0");
  return `${M}-${D}-${Y} ${h}:${mm}:${ss} ${ampm}`;
}

/** Daypart / sunlight label (optional section) */
function daypartLabel({ buckets, is_night }) {
  if (is_night === true) return "Night";
  if (is_night === false) return "Day";
  const b = (buckets && buckets[0]) || "";
  const map = {
    morning: "Morning",
    afternoon: "Afternoon",
    evening: "Evening",
    overnight: "Overnight",
    "dusk-dawn": "Dusk–Dawn",
    "dawn-dusk": "Dawn–Dusk",
  };
  return map[b] || "";
}

export default function QuerySummary({
  start,
  end,
  cameras = [],
  plate = "",
  exact = false,
  total = 0,
  visible = 0,
  buckets = [],
  is_night = null,
}) {
  const range = `${fmtMDYHms12(start)} > ${fmtMDYHms12(end)}`;
  const cams =
    (cameras && cameras.length
      ? cameras.map(prettyCamName).join(", ")
      : "—") || "—";
  const plateText = plate ? `${plate}${exact ? " (exact)" : ""}` : "—";
  const dp = daypartLabel({ buckets, is_night });

  return (
    <div
      className="card"
      style={{
        padding: 10,
        marginTop: 8,
      }}
    >
      <div style={{ fontSize: 12, opacity: 0.9 }}>
        <strong>Selected timeframe:</strong> {range} · <strong>Cameras:</strong>{" "}
        {cams}
        {dp ? (
          <>
            {" "}
            · <strong>{dp}</strong>
          </>
        ) : null}{" "}
        · <strong>Plate:</strong> {plateText} · <strong>Showing</strong>{" "}
        {visible} of {total}
      </div>
    </div>
  );
}
